import { render } from "./select-payment-methods.vue?vue&type=template&id=dd2a2816&ts=true"
import script from "./select-payment-methods.vue?vue&type=script&lang=ts"
export * from "./select-payment-methods.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__